import { getUriParams } from '../../../helpers';
import { notasFiscaisDevedorFactory } from '../../../pages/NotasFiscaisDevedor/NotasFiscaisDevedorFactory';
import {
  CORE,
  gateway,
  RELATORIOS,
} from '../../api';

export default {
  buscarInfoNotaFiscalDevedor(formFields, pageable, order, idsProcessosExcluidos) {
    const payload = notasFiscaisDevedorFactory.buildPayloadFormFields(formFields, idsProcessosExcluidos);

    const sortedQuery = order.reduce((obj, sort) => `${obj}&sort=${sort}`, '');
    const queryParam = getUriParams(pageable);

    return gateway.post(`${CORE}/nota-fiscal-devedor/buscar?${queryParam}${sortedQuery}`, payload);
  },
  buscarResumoNotaFiscalDevedor(formFields, idsProcessosExcluidos) {
    const payload = notasFiscaisDevedorFactory.buildPayloadFormFields(formFields, idsProcessosExcluidos);

    return gateway.post(`${CORE}/nota-fiscal-devedor/buscar-resumo`, payload);
  },

  buscarIdsNotaFiscalDevedor(formFields, idsProcessosExcluidos) {
    const payload = notasFiscaisDevedorFactory.buildPayloadFormFields(formFields, idsProcessosExcluidos);
    return gateway.post(`${CORE}/nota-fiscal-devedor/ids`, payload);
  },

  gerarNotaFiscalDevedor(conteudoSelecionado) {
    const payload = notasFiscaisDevedorFactory.buildPayloadGerarNotaFiscalDevedor(conteudoSelecionado);
    return gateway.post(`${CORE}/nota-fiscal-devedor/gerar-nota-fiscal`, payload);
  },

  exportarNotaFiscalDevedor(formFields, dadosResumo, idsProcessosExcluidos) {
    const payload = notasFiscaisDevedorFactory.buildPayloadNotaFiscalDevedor(formFields, dadosResumo, idsProcessosExcluidos);

    return gateway.post(`${RELATORIOS}/nota-fiscal-devedor/exportar`, payload);
  },

  downloadArquivoRemessa(idNotaFiscalClienteRemessa) {
    return gateway.get(`${CORE}/nota-fiscal-devedor/download-nota-fiscal/${idNotaFiscalClienteRemessa}`);
  },
};
